import axiosInstance from "shared/services";
import { ILiveCamerasResponse } from "modules/live-cameras/types";
import { ICameras } from "modules/cameras/types";

const uri = "live-cameras";

export const all = async (): Promise<ILiveCamerasResponse> => {
  return axiosInstance.get(`${uri}/all`).then();
};

export const liveFilter = async (
  companyId?: number,
  page?: number
): Promise<ICameras> => {
  return axiosInstance
    .get(`/${uri}?company_id=${!companyId ? "" : companyId}&page=${page}`)
    .then();
};
